// src/components/molecules/AddTagButton/AddTagButton.jsx
import React from 'react';
import PropTypes from 'prop-types';
import { IconButton, useTheme } from '@mui/material';
import { LocalOffer } from '@mui/icons-material';
import Tooltip from '../../atoms/Tooltip/Tooltip';
import {
  getOperationalMode,
  operationalComponentSurfaces,
  operationalRadii
} from '../../../design-system/tokens';

const AddTagButton = ({
  onClick,
  tooltip = 'Adicionar tags',
  size = 'small',
  className = '',
  sx,
  ...props
}) => {
  const theme = useTheme();
  const chipTokens = operationalComponentSurfaces.chip[getOperationalMode(theme.palette.mode)];

  return (
    <Tooltip title={tooltip} placement="top" arrow>
      <IconButton
        size={size}
        className={`add-tag-button ${className}`}
        onClick={onClick}
        sx={{
          // Mesma altura e forma dos TagChips
          width: 28,
          height: 28,
          borderRadius: `${operationalRadii.control}px`,
          // Mesmo fundo dos TagChips
          backgroundColor: chipTokens.background,
          opacity: 0.82,
          transition: 'all 0.2s ease',
          '&:hover': {
            backgroundColor: chipTokens.backgroundHover,
            opacity: 0.98,
            transform: 'translateY(-1px)',
          },
          ...sx
        }}
        {...props}
      >
        <LocalOffer sx={{
          fontSize: '0.8rem',
          color: chipTokens.text
        }} />
      </IconButton>
    </Tooltip>
  );
};

AddTagButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  tooltip: PropTypes.string,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  className: PropTypes.string,
  sx: PropTypes.object
};

export default AddTagButton;
